export default "__VITE_ASSET__9gEXrJQh__"